// extracted by mini-css-extract-plugin
export var divider = "_of-0";
export var systemMessage = "_of-1";
export var systemMessageWrapper = "_of-2";